<template>
  <header class="header">
    <div>
      <burger-menu v-if="!user" :links="links" class="burger-menu" />
      <authorize-burger-menu v-else :links="links" class="burger-menu" />
      <logo />
    </div>
    <actions-bar :links="accountBarLinks" />
    <authorized-bar-buttons v-if="user" />
    <unauthorize-bar-buttons v-else />
  </header>
</template>

<script>
import firebase from 'firebase/app';

import Logo from '@/components/header/Logo.vue';
import ActionsBar from '@/components/header/ActionsBar.vue';
import UnauthorizeBarButtons from '@/components/header/UnauthorizeBarButtons.vue';
import AuthorizedBarButtons from '@/components/header/AuthorizedBarButtons.vue';
import BurgerMenu from '@/components/header/BurgerMenu.vue';
import AuthorizeBurgerMenu from '@/components/header/AuthorizeBurgerMenu.vue';

import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    Logo,
    ActionsBar,
    UnauthorizeBarButtons,
    BurgerMenu,
    AuthorizeBurgerMenu,
    AuthorizedBarButtons,
  },
  data() {
    return {
      links: [
        {
          to: ROUTER_PATHS.PROBLEMS,
          label: this.$t('problems'),
        },
        {
          to: ROUTER_PATHS.REWARDS,
          label: this.$t('rewards'),
        },
        {
          to: ROUTER_PATHS.PROMISES,
          label: this.$t('promises'),
        },
        {
          to: ROUTER_PATHS.TARGETING,
          label: this.$t('targeting'),
        },
      ],
    };
  },
  computed: {
    user() {
      return firebase.auth().currentUser;
    },
    accountBarLinks() {
      const accountLink = {
        to: ROUTER_PATHS.ACCOUNT,
        label: this.$t('account'),
      };

      return this.user ? [...this.links, accountLink] : this.links;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/breakpoints';

header {
  display: flex;
  padding: $container-padding;
  justify-content: space-between;
  align-items: center;
  background-color: $white;
  width: 100%;
  z-index: 2;
  height: $bar-height;
  box-shadow: 0 0 $shadow-size $shadow;
  font-size: $font-size-base;
  position: fixed;
}

.burger-menu {
  display: none;
}

@media (max-width: $header-breakpoint) {
  .burger-menu {
    display: block;
  }
}
</style>
